import React from 'react';

export default function Modal({ title, onClose, children }) {
  return (
    <div className="fixed inset-0 bg-ink-primary/40 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-surface-100 border rounded-lg p-6 max-w-[500px] w-[90%] max-h-[85vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button onClick={onClose} className="bg-transparent border-none text-xl text-ink-muted cursor-pointer p-1 hover:text-ink-primary">
            &times;
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
